import GreenButton from "@/src/common/buttons/greenButton"

import { Stack, Typography } from "@mui/material"

interface Props {
    onButtonClicked: () => void
    headerText: string
    subText1: string
    subText2?: string
    buttonText: string
    image: JSX.Element
    buttonRefreshIcon?: string
    height?: number
}

export const FullPageError = (props: Props) => (
    <Stack
        style={{ height: `${props.height ? props.height : "60"}vh`, padding: "0 16px" }}
        alignItems="center"
        justifyContent="center"
    >
        {props.image}
        <Typography style={{ color: "#31445a", marginTop: "24px" }}>{props.headerText}</Typography>
        <Typography style={{ marginTop: "8px", maxWidth: "400px", textAlign: "center" }}>{props.subText1}</Typography>
        {props.subText2 ? (
            <Typography style={{ color: "#172B4D", marginTop: "24px", textAlign: "center" }}>
                {props.subText2}
            </Typography>
        ) : (
            ""
        )}
        <GreenButton
            onClick={props.onButtonClicked}
            style={{ marginTop: "16px", flexGrow: 0 }}
            startIcon={props.buttonRefreshIcon ? <img src={props.buttonRefreshIcon} alt="" /> : undefined}
        >
            {props.buttonText}
        </GreenButton>
    </Stack>
)
